import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

export default function useDataTransform(props, data) {
  let to = useDataValue({
    context: 'comms_settings',
    path: 'to',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (to === null) return data
    return data.filter(d => d.id < to)
  }, [data, to])
}
